import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Routes from './Routes';

const Router = createBrowserRouter(Routes, { basename: '/sc/roaming' });

const MainRouter = () => {
  return <RouterProvider router={Router} />;
};
export default MainRouter;
